import { environment, Role } from '@perval/shared';

export interface MenuItem {
  label: string;
  route: string;
  requiredRoles: Role[];
  v2?: boolean;
  subMenu?: MenuItem[];
}

export const MAIN_MENU: MenuItem[] = [
  {
    label: 'Recherche de références',
    route: `${environment.host}/recherche-references`,
    requiredRoles: [
      Role.ADMIN,
      Role.NOTARY,
      Role.COLLABORATOR,
      Role.COLLABORATOR_LIMITED,
    ],
  },
  {
    label: 'Évaluation automatique',
    route: `${environment.host}/evaluation-automatique`,
    requiredRoles: [Role.ADMIN, Role.NOTARY, Role.COLLABORATOR, Role.SF_LISTE],
  },
  {
    label: 'Actualisation de la valeur',
    route: `${environment.host}/actualisation-valeurs`,
    requiredRoles: [
      Role.ADMIN,
      Role.NOTARY,
      Role.COLLABORATOR,
      Role.SF_LISTE,
      Role.ACTU_VAL,
    ],
  },
  {
    label: 'Statistiques',
    route: '',
    requiredRoles: [Role.STATISTICS_FULL_VIEW],
    subMenu: [
      {
        label: 'Indices des prix',
        route: `${environment.host}/statistiques-immobilieres-indices`,
        requiredRoles: [],
      },
      {
        label: 'Statistiques avant-contrats',
        route: `${environment.host}/statistiques-immobilieres-avct`,
        requiredRoles: [],
      },
    ],
  },
  {
    label: 'Guides utilisateur',
    route: '',
    requiredRoles: [],
    subMenu: [
      {
        label: 'Recherche références',
        route: `/aide-recherche`,
        requiredRoles: [],
        v2: true,
      },
    ],
  },
  {
    label: 'Backoffice',
    route: `/admin`,
    requiredRoles: [
      Role.ADMIN_CONSUMPTIONTRACKING_EXPORT,
      Role.ADMIN_XNOTACCOUNT_CREATE,
    ],
    v2: true,
  },
];
